var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("path", {
      attrs: {
        stroke: _vm.color1,
        d: "M7.44522 2.40569L7.99997 3.31438L8.55477 2.40572C9.42834 0.974949 11.1288 0.429878 12.6514 0.740254C14.1493 1.04558 15.35 2.14655 15.35 3.94044C15.35 5.1624 14.5764 6.50197 13.1231 8.12637C12.0514 9.32426 10.6913 10.5928 9.17189 12.01C8.79062 12.3657 8.39933 12.7306 8.00003 13.1062C7.59976 12.7297 7.20751 12.3638 6.82534 12.0073C5.30726 10.5912 3.94826 9.32349 2.87716 8.12636C1.42376 6.50193 0.65 5.16237 0.65 3.94044C0.65 2.15251 1.84864 1.04543 3.34473 0.735807C4.8635 0.421487 6.56373 0.961825 7.44522 2.40569Z",
        "stroke-width": "1.3",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }